<template>
  <div>
    <a-card style="margin: 10px 0">
      <div >
        <a-form class="filter-section" layout="inline" ref="form" :model="form">
          <a-form-item name="id">
            <a-input style="width: 200px" placeholder="请输入下载ID号" v-model:value="form.id" autocomplete="off">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData(1)">搜索</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">数据下载列表</p>
      </div>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span>
            <a @click="openDownload(record)"
              v-if="record.state === 'finished' && record.zipLocation">下载</a>
            <a-divider type="vertical"/>
            <a v-if="record.state === 'finished'" @click="openDetail(record)">查看</a>
            <a-divider type="vertical"/>
            <a @click="showDeleteConfirm(record)">删除</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <DetailDialog ref="detailDialog" :currentItem="currentItem" @update="getData(1)"></DetailDialog>
    <AddDownload ref="addDownload" :currentItem="currentItem"></AddDownload>
  </div>
</template>
<script>
import { getPakageByPage, deletePakage } from '@/api/dataDownload'
import { getDateTime, getUserName } from '@/filters'
import config from '@/config'
import { mapState } from 'vuex'
import DetailDialog from './DetailDialog'
import AddDownload from './AddDownload'
const columns = [
  {
    title: '下载包ID',
    dataIndex: 'id'
  },
  {
    title: '下载包名称',
    dataIndex: 'createName'
  },
  {
    title: '创建人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '处理状态',
    dataIndex: 'state'
  },
  {
    title: '处理信息',
    dataIndex: 'dealDetail'
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    DetailDialog,
    AddDownload
  },
  data () {
    return {
      btnPerm: config.btnPerm,
      form: {
        id: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      currentItem: {}
    }
  },
  computed: {
    ...mapState(['currentRole'])
  },
  mounted () {
    this.getData()
  },
  methods: {
    getDateTime,
    getUserName,
    changeTab (key) {
      console.log(key)
    },
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getPakageByPage({ ...this.form, ...this.page }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
      })
    },
    openDownload (item) {
      if (!item.zipLocation) {
        this.$message.error('下载地址无效')
        return
      }
      this.currentItem = item
      this.$refs.addDownload.open()
    },
    // 查看数据
    openDetail (item) {
      this.currentItem = item
      this.$refs.detailDialog.open()
    },
    // 单个删除确认
    showDeleteConfirm (item) {
      this.$confirm({
        title: '删除下载记录',
        content: '确认删除此条下载记录？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          this.handleDelete([item.id])
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    // 删除
    async handleDelete (ids) {
      this.loading = true
      for (const id of ids) {
        await deletePakage(id).catch(e => e)
      }
      this.loading = false
      this.getData()
    }
  }
}
</script>
<style>

</style>
